import React from 'react';
import styled from 'styled-components';
import {isMobileOnly} from 'react-device-detect';
import SpanPckgNavPrice from '../common/price/SpanPckgNavPrice';

const EsOrderDoneBrListItemBlock = styled.div`
    position: relative;
    padding-top: 20px;
    padding-bottom: 20px;
    //border-bottom: 1px solid #cccccc;
    padding: 20px 16px;

    .black {
        color: #333333;
    }
    .green {
        color: #79b88a;
    }
    .gray {
        color: #999999;
    }
    .pink {
        color: #fc1c67;
    }

    .pointer {
        cursor: pointer;
    }
`;

const EsOrderDoneBrListItemImgBlock = styled.div`
    ${isMobileOnly?`
    width: 98px;
    float: left;
    height: 98px;
    `:`
    margin-left: 20px;
    width: 100px;
    float: left;
    height: 100px;
    `};

`;

const EsOrderDoneBrListItemTextBlock = styled.div`
    padding: 0 20px;
    float: left;
    width: 740px;
`;

const EsOrderDoneBrListItemTitleBlock = styled.p`
    display: -webkit-box;
    height: 42px;
    font-size: 14px;
    word-wrap: break-word;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    font-size: 14px;
    color: #333333;
`;

const EsOrderDoneBrListItemOptionBlock = styled.div`
    position: absolute;
    bottom: 40px;
    color: #666666;
    font-size: 14px;
`;

const EsOrderDoneBrListItemQtyBlock = styled.div`
    position: absolute;
    bottom: 20px;
    color: #999999;
    font-size: 14px;
`;

const EsOrderDoneBrListItemPriceBlock = styled.div`
    float: right;
    width: 158px;
    text-align: right;
    vertical-align: middle;
    line-height: 1.5;
    display: table;
    height: 100px;
    padding-right: 20px;
`;

const EsOrderDoneBrListItemPriceInnerBlock = styled.div`
    vertical-align: middle;
    display: table-cell;
`;


const MobileEsOrderDoneBrListItemBlock = styled.div`
    padding: 20px 16px 10px;

    .pointer {
        cursor: pointer;
    }
`;

const MobileEsOrderDoneBrListItemInfoBlock = styled.div`
      height: 98px;
`;

const MobileEsOrderDoneBrListItemNameContainerBlock = styled.div`
    float: left;
    width: calc(88vw - 122px);
    padding-left: 10px;
`;

const MobileEsOrderDoneBrListItemNameBlock = styled.div`
    font-size: 14px;
    font-weight: normal;
    line-height: 1.43;
    letter-spacing: normal;
    text-align: left;
    color: #333333;
    margin-bottom: 10px;

    max-height: 42px;
    display: -webkit-box;
    word-wrap: break-word;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
`;

const MobileEsOrderDoneBrListItemOptionBlock = styled.div`
    font-size: 12px;
    font-weight: normal;
    line-height: 1.4;
    letter-spacing: normal;
    text-align: left;
    color: #666666;
    margin-bottom: 10px;
`;

const MobileEsOrderDoneBrListItemNumBlock = styled.div`
    font-size: 12px;
    font-weight: normal;
    line-height: 1.4;
    letter-spacing: normal;
    text-align: left;
    color: #999999;
    margin-bottom: 10px;
`;

const MobileEsOrderDoneBrListItemControlBlock = styled.div`
    //margin-top: 10px;
    position: relative;
    //padding-right: 16px;
`;

const EsOrderDonePckgProdImgBtnBlock = styled.img`
    border-radius: 4px;
    min-width: 100%;
    height: 100%;
    vertical-align: middle;
    object-fit: cover;
`;

const EsOrderDoneDeliveryBlock = styled.div`
    ${isMobileOnly?`
    padding: 7px 10px;
    margin: 20px 0 0px;
    `:`
    padding: 7px 20px;
    margin: 0 16px;
    `};

    position: relative;
    height: 32px;
    background-color: #fafafa;
    
`;

const EsOrderDoneDeliveryTextBlock = styled.div`
    float: right;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 18px;
    color: #999999;
    text-align: right;

    ::before {
        content: '';
        display: inline-block;
        width: 22px;
        height: 13px;
        margin-right: 8px;
        background: url(/assets/images/icon/truck_gray.svg) center center/auto no-repeat;
        vertical-align: -2px;
    }
`;

const EsOrderDoneStatusBlock = styled.p`
    ${isMobileOnly?`
    
    `:`
    margin-bottom: 4px;
    `};
    
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: right;
`;
const EsOrderDoneBrListItem = ({item, isEsInfo, orderinfo}) => {

    

    const isOptionDisp = () => {
        if (item.opt_nm === null || item.opt_nm === '' ||
            item.opt_nm === item.prdct_nm) {
            return 'none';
        } else {
            return 'block';
        }
    }

    const getDlvryPrice = () => {

        // 선불
        if (item.od_dlvy_pay_type === '025201') {
            return (<p className='f-right'>선불 배송비<span> {Number(item.od_dlvry_fee.toFixed(1)).toLocaleString()}</span>원</p>)
        } else if (item.od_dlvy_pay_type === '025202') { // 착불
            return (<p className='f-right'>예상 착불 배송비<span> {Number(item.od_dlvry_fee.toFixed(1)).toLocaleString()}</span>원</p>)
        } else {
            return (<p className='f-right'>무료배송</p>)
        }
    }


    const getStatus = () => {

        let textProps = {
            "150201":"입금 대기",
            "150202":"입금 완료",
            "150203":"결제 완료",
            "150204":"출고 요청",
            "150205":"출고 준비중",
            "150206":"출고 완료",
            "150207":"배송중",
            "150208":"배송 완료",
            "150209":"구매 확정",
            "150102":"구매 취소",
        }

        let text = textProps[item.rqst_stts];

       /*  if(dday > 0) {
            text = "입금 대기"
        } else {
            text = "입금 기한 만료"
        } */

        //console.log("text = " + text)

        if(item.memo_type === '151001' && item.memo_status === "151106") {
            text = "주문 취소"
            return <span className="pink">{text}</span>
        }

        if(item.rqst_stts  === '150102') {
            return <span className="pink">{text}</span>
        } else if(item.rqst_stts  === '150201' && orderinfo.dday > 0) {
            return <span className="green">{text}</span>
        } else if(item.rqst_stts  === '150201') {
            return <span className="gray">입금 기한 만료</span>
        } else {
            return <span className="black">{text}</span>
        }
    }

    const getPay = () => {
        if (item.od_dlvy_pay_type === '025201') {
            let pay = item.od_it_pay_price - item.od_dlvry_fee;
            return pay;
        }

        return item.od_it_pay_price;
    }

    const goToProduct = () => {
        let url = "/prod?prodid=" + item.prdct_id;
        var win = window.open(url, '_blank');
        win.focus();
    }

    return (isMobileOnly? //mobile
        <MobileEsOrderDoneBrListItemBlock>
            <MobileEsOrderDoneBrListItemInfoBlock className="clearfix">
                <EsOrderDoneBrListItemImgBlock onClick={goToProduct} className="pointer">
                    <EsOrderDonePckgProdImgBtnBlock src={item.od_repr_img}/>
                </EsOrderDoneBrListItemImgBlock>
                <MobileEsOrderDoneBrListItemNameContainerBlock>
                    <MobileEsOrderDoneBrListItemNameBlock onClick={goToProduct} className="pointer">{item.prdct_nm}</MobileEsOrderDoneBrListItemNameBlock>
                    {item.opt_nm&&<MobileEsOrderDoneBrListItemOptionBlock onClick={goToProduct} className="pointer">
                    {item.opt_nm}
                    </MobileEsOrderDoneBrListItemOptionBlock>}
                    <MobileEsOrderDoneBrListItemNumBlock onClick={goToProduct} className="pointer">
                    <p><span>수량 : {item.qty}개</span></p>
                    </MobileEsOrderDoneBrListItemNumBlock>
                </MobileEsOrderDoneBrListItemNameContainerBlock>
                
            </MobileEsOrderDoneBrListItemInfoBlock>
            {isEsInfo?
            <MobileEsOrderDoneBrListItemControlBlock className="clearfix">
                <div style={{float: 'right', paddingTop: '0px'}}>
                    <SpanPckgNavPrice value={getPay()}
                    fontSize='18px' fontWeight='500' wonFontSize='18px' float='none' />
                </div>  
                <div style={{float: 'right', marginRight: '8px', paddingTop: '8px'}}>
                <EsOrderDoneStatusBlock>{getStatus()}</EsOrderDoneStatusBlock>
                </div> 
            </MobileEsOrderDoneBrListItemControlBlock>
            :
            <MobileEsOrderDoneBrListItemControlBlock className="clearfix">
                
                <div style={{float: 'right', paddingTop: '0px'}}>
                    <SpanPckgNavPrice value={getPay()}
                    fontSize='14px' fontWeight='500' wonFontSize='14px' float='none' />
                </div>  
                <div style={{float: 'right', marginRight: '8px', paddingTop: '2px'}}>
                <SpanPckgNavPrice value={item.od_prdct_price} fontSize='12px' fontWeight='500' wonFontSize='12px' float='none' isSale={true}/>
                </div>   
            </MobileEsOrderDoneBrListItemControlBlock>
            }
            
            <EsOrderDoneDeliveryBlock> 
                <EsOrderDoneDeliveryTextBlock>{getDlvryPrice()}</EsOrderDoneDeliveryTextBlock>
            </EsOrderDoneDeliveryBlock>
        </MobileEsOrderDoneBrListItemBlock>
        : //desktop
        <div className="clearfix">
        <EsOrderDoneBrListItemBlock className="clearfix">
            <EsOrderDoneBrListItemImgBlock onClick={goToProduct} className="pointer">
                <EsOrderDonePckgProdImgBtnBlock src={item.od_repr_img}/>
            </EsOrderDoneBrListItemImgBlock>
            <EsOrderDoneBrListItemTextBlock>
                <EsOrderDoneBrListItemTitleBlock onClick={goToProduct} className="pointer">
                    {item.prdct_nm}
                </EsOrderDoneBrListItemTitleBlock>
                <EsOrderDoneBrListItemOptionBlock style={{ display: isOptionDisp() }} onClick={goToProduct} className="pointer">
                    <p><span>옵션 : {item.opt_nm}</span></p>
                </EsOrderDoneBrListItemOptionBlock>
                <EsOrderDoneBrListItemQtyBlock onClick={goToProduct} className="pointer">
                    <p><span>수량 : {item.qty}개</span></p>
                </EsOrderDoneBrListItemQtyBlock>
            </EsOrderDoneBrListItemTextBlock>
            <EsOrderDoneBrListItemPriceBlock>
            {isEsInfo?
                <EsOrderDoneBrListItemPriceInnerBlock>
                   <EsOrderDoneStatusBlock>{getStatus()}</EsOrderDoneStatusBlock>
                   {/* <SpanPckgNavPrice value={item.od_prdct_price} fontSize='12px' fontWeight='300' wonFontSize='12px' float='none' isSale={true}/> */}
                       <SpanPckgNavPrice value={getPay()}
                       fontSize='14px' fontWeight='500' wonFontSize='14px' float='none' />
                   </EsOrderDoneBrListItemPriceInnerBlock>
            :    
                <EsOrderDoneBrListItemPriceInnerBlock>
                   <SpanPckgNavPrice value={item.od_prdct_price} fontSize='12px' fontWeight='300' wonFontSize='12px' float='none' isSale={true}/>
                       <SpanPckgNavPrice value={getPay()}
                       fontSize='14px' fontWeight='500' wonFontSize='14px' float='none' />
                   </EsOrderDoneBrListItemPriceInnerBlock>
            }
                
            </EsOrderDoneBrListItemPriceBlock>
        </EsOrderDoneBrListItemBlock>
        <EsOrderDoneDeliveryBlock> 
            <EsOrderDoneDeliveryTextBlock>{getDlvryPrice()}</EsOrderDoneDeliveryTextBlock>
        </EsOrderDoneDeliveryBlock>
        </div>
    );
};

export default EsOrderDoneBrListItem;